export function useQuoteCalculator(values) {
  // Contract: returns a simple integer price in RSD based on inputs
  const base = 5000; // osnovna cena
  const floorPrice = 500; // po spratu bez lifta
  const itemPrice = 200; // po stavci
  const extrasPrice = 1500; // grubo

  const fromFloor = (values?.from?.elevator ? 0 : (values?.from?.floor || 0));
  const toFloor = (values?.to?.elevator ? 0 : (values?.to?.floor || 0));

  let items = 0;
  const inv = values?.inventory || {};
  Object.values(inv).forEach(v => {
    if (v?.selected) items += (v?.qty || 0);
  });

  let total = base + floorPrice * (fromFloor + toFloor) + itemPrice * items;
  if (values?.extras?.assembly) total += extrasPrice;
  if (values?.extras?.packing) total += extrasPrice;

  return Math.max(0, Math.round(total));
}
